import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp, FaPlay,FaUniversity,FaDownload, FaCalendarAlt, FaMoneyBillWave, FaFileAlt, FaUserGraduate, FaCertificate, FaIdCard } from 'react-icons/fa';
import "../../Component/Admission.css"


const Admissions = () => {
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    childName: '',
    grade: '',
    message: ''
  });

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Form submission logic
    console.log(formData);
  };

  const admissionProcess = [
    { step: 1, title: "Enquiry & Campus Visit", icon: <FaCalendarAlt />, image: "assets/images/Moments/moments_2.webp" },
    { step: 2, title: "Entrance Assessment", icon: <FaFileAlt />, image: "assets/images/Moments/moments_1.webp" },
    { step: 3, title: "Academic Team Interaction", icon: <FaUserGraduate />, image: "assets/images/Moments/moments_5.webp" },
    { step: 4, title: "Admission Offer", icon: <FaCertificate />, image: "/assets/images/Moments/moments_3.webp" },
    { step: 5, title: "Fee Payment & Orientation", icon: <FaMoneyBillWave />, image: "assets/images/Moments/moments_4.webp" }
  ];

  const requiredDocuments = [
    { name: "Birth Certificate", icon: <FaIdCard /> },
    { name: "Aadhar Card", icon: <FaIdCard /> },
    { name: "Transfer Certificate", icon: <FaFileAlt /> },
    { name: "Passport Photos", icon: <FaIdCard /> }
  ];

  const testimonials = [
    {
      quote: "The personalized attention my child receives is remarkable. DNET truly understands individual learning needs.",
      author: "Mrs. Sharma, Grade 3 Parent",
      image: "assets/images/slider/courses_1.webp"
    },
    {
      quote: "The innovative curriculum has sparked a love for learning in our daughter we've never seen before.",
      author: "Mr. Patel, Grade 7 Parent",
      image: "assets/images/slider/courses_3.webp"
    },
    {
      quote: "From admission to daily learning, every process at DNET is well-structured and transparent.",
      author: "Dr. Gupta, Kindergarten Parent",
      image: "assets/images/slider/courses_2.webp"
    }
  ];

  const whyChooseUs = [
    {
      title: "Personalized Learning Paths",
      description: "Customized education plans tailored to each student's strengths and needs",
      image: "assets/images/banner1.jpg",
      icon: "🎯"
    },
    {
      title: "Innovation-Centric Curriculum",
      description: "Cutting-edge programs that foster creativity and critical thinking",
      image: "assets/images/banner3.jpg",
      icon: "💡"
    },
    {
      title: "Consistent Academic Excellence",
      description: "Proven track record of outstanding student achievements",
      image: "assets/images/banner5.jpg",
      icon: "🏆"
    }
  ];


  const tuitionData = [
    { term: 'Fall 2020', amount: 12000 },
    { term: 'Spring 2021', amount: 14000 },
    { term: 'Summer 2020', amount: 10000 },
    { term: 'Fall 2022', amount: 15000 },
    { term: 'Spring 2021', amount: 12000 }
  ];

  const total = tuitionData.reduce((sum, item) => sum + item.amount, 0);

  return (
    <div className="admissions-page">
      {/* Hero Section with Background Image */}
      <section className="Subpage_Hero">
        <div className="container">
          <div className="text-lg-start" data-aos="fade-up">
            <h1>Our Admission</h1>
            <p>
              This page must stand out with icons, infographics, student videos, and success stories. 
            </p>
          </div>
        </div>
      </section>

      {/* Video Modal */}
      {showVideoModal && (
        <div className="video-modal">
          <div className="modal-content1">
            <button className="modal-close text-danger p-2" onClick={() => setShowVideoModal(false)}>
              &times;
            </button>
            <div className="video-wrapper">
              <iframe 
                src="assets/images/tour.mp4" 
                title="DNET Virtual Tour" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}

      {/* Admission Process with Images */}
      <section className="process-section ">
        <div className="container">
          <h2 className='h2 display-6 fw-bold'>Our Simple Admission Process</h2>
          <div className="process-steps">
            {admissionProcess.map((item) => (
              <div key={item.step} className="process-step">
                <div className="step-image-container">
                  <img src={item.image} alt={item.title} className="step-image" />
                  <div className="step-icon position-absolute ">{item.icon}</div>
                </div>
                <div className="step-number">Step {item.step}</div>
                <h3>{item.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>
      

      

      {/* Two Column Layout */}
      <section className="two-column-section">
        <div className="container">
          <div className="columns">
            {/* Left Column - Form */}
            <div className="form-column" style={{
        background: "white",
        borderRadius: "24px",
        padding: "40px",
        boxShadow: "0 10px 40px rgba(32, 13, 70, 0.08)",
        position: "relative",
        overflow: "hidden"
      }}>
        {/* Decorative Elements */}
        <div style={{
          position: "absolute",
          top: "-50px",
          right: "-50px",
          width: "200px",
          height: "200px",
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(109,40,217,0.1) 0%, transparent 70%)",
          zIndex: 0
        }}></div>
        
        <div className="form-header" style={{marginBottom: "32px", position: "relative", zIndex: 1}}>
          <h2 style={{
            fontSize: "2rem",
            fontWeight: "700",
            color: "#200D46",
            marginBottom: "8px",
            background: "linear-gradient(90deg, #200D46, #6D28D9)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            color: "transparent"
          }}>Start Your Application</h2>
          <p style={{color: "#64748B", fontSize: "1rem"}}>Complete this form to begin the admission process</p>
        </div>
        
        <form onSubmit={handleSubmit} style={{position: "relative", zIndex: 1}}>
  {/* Grid Layout for First 4 Fields */}
  <div className="form-grid" style={{
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "20px",
    marginBottom: "24px"
  }}>
    {/* Parent's Name */}
    <div className="form-group">
      <label style={{
        display: "block",
        marginBottom: "8px",
        fontWeight: "600",
        color: "#200D46",
        fontSize: "0.9rem"
      }}>Parent's Name</label>
      <input 
        type="text" 
        name="name" 
        value={formData.name} 
        onChange={handleChange} 
        required 
        style={{
          width: "100%",
          padding: "12px 16px",
          borderRadius: "12px",
          border: "1px solid #E2E8F0",
          transition: "all 0.3s ease",
          fontSize: "1rem"
        }}
        onFocus={(e) => {
          e.target.style.borderColor = "#8B5CF6";
          e.target.style.boxShadow = "0 0 0 3px rgba(139, 92, 246, 0.2)";
        }}
        onBlur={(e) => {
          e.target.style.borderColor = "#E2E8F0";
          e.target.style.boxShadow = "none";
        }}
      />
    </div>
    
    {/* Email */}
    <div className="form-group">
      <label style={{
        display: "block",
        marginBottom: "8px",
        fontWeight: "600",
        color: "#200D46",
        fontSize: "0.9rem"
      }}>Email</label>
      <input 
        type="email" 
        name="email" 
        value={formData.email} 
        onChange={handleChange} 
        required 
        style={{
          width: "100%",
          padding: "12px 16px",
          borderRadius: "12px",
          border: "1px solid #E2E8F0",
          transition: "all 0.3s ease",
          fontSize: "1rem"
        }}
        onFocus={(e) => {
          e.target.style.borderColor = "#8B5CF6";
          e.target.style.boxShadow = "0 0 0 3px rgba(139, 92, 246, 0.2)";
        }}
        onBlur={(e) => {
          e.target.style.borderColor = "#E2E8F0";
          e.target.style.boxShadow = "none";
        }}
      />
    </div>
    
    {/* Phone */}
    <div className="form-group">
      <label style={{
        display: "block",
        marginBottom: "8px",
        fontWeight: "600",
        color: "#200D46",
        fontSize: "0.9rem"
      }}>Phone</label>
      <input 
        type="tel" 
        name="phone" 
        value={formData.phone} 
        onChange={handleChange} 
        required 
        style={{
          width: "100%",
          padding: "12px 16px",
          borderRadius: "12px",
          border: "1px solid #E2E8F0",
          transition: "all 0.3s ease",
          fontSize: "1rem"
        }}
        onFocus={(e) => {
          e.target.style.borderColor = "#8B5CF6";
          e.target.style.boxShadow = "0 0 0 3px rgba(139, 92, 246, 0.2)";
        }}
        onBlur={(e) => {
          e.target.style.borderColor = "#E2E8F0";
          e.target.style.boxShadow = "none";
        }}
      />
    </div>
    
    {/* Child's Name */}
    <div className="form-group">
      <label style={{
        display: "block",
        marginBottom: "8px",
        fontWeight: "600",
        color: "#200D46",
        fontSize: "0.9rem"
      }}>Child's Name</label>
      <input 
        type="text" 
        name="childName" 
        value={formData.childName} 
        onChange={handleChange} 
        required 
        style={{
          width: "100%",
          padding: "12px 16px",
          borderRadius: "12px",
          border: "1px solid #E2E8F0",
          transition: "all 0.3s ease",
          fontSize: "1rem"
        }}
        onFocus={(e) => {
          e.target.style.borderColor = "#8B5CF6";
          e.target.style.boxShadow = "0 0 0 3px rgba(139, 92, 246, 0.2)";
        }}
        onBlur={(e) => {
          e.target.style.borderColor = "#E2E8F0";
          e.target.style.boxShadow = "none";
        }}
      />
    </div>
  </div>
  
  {/* Full Width Fields */}
  <div style={{marginBottom: "24px"}}>
    {/* Grade Selection */}
    <div className="form-group" style={{marginBottom: "24px"}}>
      <label style={{
        display: "block",
        marginBottom: "8px",
        fontWeight: "600",
        color: "#200D46",
        fontSize: "0.9rem"
      }}>Grade Applying For</label>
      <select 
        name="grade" 
        value={formData.grade} 
        onChange={handleChange} 
        required
        style={{
          width: "100%",
          padding: "12px 16px",
          borderRadius: "12px",
          border: "1px solid #E2E8F0",
          transition: "all 0.3s ease",
          fontSize: "1rem",
          appearance: "none",
          backgroundImage: "url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23200D46' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\")",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right 16px center",
          backgroundSize: "16px"
        }}
        onFocus={(e) => {
          e.target.style.borderColor = "#8B5CF6";
          e.target.style.boxShadow = "0 0 0 3px rgba(139, 92, 246, 0.2)";
        }}
        onBlur={(e) => {
          e.target.style.borderColor = "#E2E8F0";
          e.target.style.boxShadow = "none";
        }}
      >
        <option value="">Select Grade</option>
        <option value="Kindergarten">Kindergarten</option>
        <option value="Grade 1-5">Grade 1-5</option>
        <option value="Grade 6-8">Grade 6-8</option>
        <option value="Grade 9-12">Grade 9-12</option>
      </select>
    </div>
    
    {/* Message */}
    <div className="form-group">
      <label style={{
        display: "block",
        marginBottom: "8px",
        fontWeight: "600",
        color: "#200D46",
        fontSize: "0.9rem"
      }}>Message</label>
      <textarea 
        name="message" 
        value={formData.message} 
        onChange={handleChange}
        style={{
          width: "100%",
          padding: "12px 16px",
          borderRadius: "12px",
          border: "1px solid #E2E8F0",
          transition: "all 0.3s ease",
          fontSize: "1rem",
          minHeight: "120px",
          resize: "vertical"
        }}
        onFocus={(e) => {
          e.target.style.borderColor = "#8B5CF6";
          e.target.style.boxShadow = "0 0 0 3px rgba(139, 92, 246, 0.2)";
        }}
        onBlur={(e) => {
          e.target.style.borderColor = "#E2E8F0";
          e.target.style.boxShadow = "none";
        }}
      ></textarea>
    </div>
  </div>
  
  {/* Submit Button */}
  <button 
    type="submit" 
    className="submit-button" 
    style={{
      background: "linear-gradient(90deg, #6D28D9, #8B5CF6)",
      color: "white",
      border: "none",
      padding: "16px 32px",
      borderRadius: "12px",
      fontWeight: "600",
      fontSize: "1rem",
      cursor: "pointer",
      width: "100%",
      marginTop: "16px",
      transition: "all 0.3s ease",
      boxShadow: "0 4px 15px rgba(109, 40, 217, 0.3)",
      position: "relative",
      overflow: "hidden"
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-2px)";
      e.currentTarget.style.boxShadow = "0 6px 20px rgba(109, 40, 217, 0.4)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "0 4px 15px rgba(109, 40, 217, 0.3)";
    }}
  >
    <span style={{position: "relative", zIndex: 2}}>Submit Application</span>
    <span style={{
      position: "absolute",
      top: "-50%",
      left: "-50%",
      width: "200%",
      height: "200%",
      background: "linear-gradient(90deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.3) 100%)",
      transform: "translateX(-100%) rotate(15deg)",
      transition: "transform 0.6s ease",
      zIndex: 1
    }}></span>
  </button>
</form>
      </div>

            {/* Right Column - Video & Documents */}
            <div className="column info-column">
              <div className="video-container1">
                <div 
                  className="video-thumbnail"
                  onClick={() => setShowVideoModal(true)}
                >
                  <img src="assets/images/banner4.jpg" alt="Virtual Tour" />
                  <div className="play-overlay">
                    <FaPlay className="play-icon" />
                    <span>Play Video</span>
                  </div>
                </div>
                <h3 className='h5 color mt-2 mb-3 fw-bold'>Experience Our Campus Virtually</h3>
                <p >Take a 360° tour of our state-of-the-art facilities and learning spaces</p>
              </div>

              <div className="documents-section">
                <h3 className='h5 color fw-bold mt-2'>Required Documents</h3>
                <div className="documents-grid">
                  {requiredDocuments.map((doc, index) => (
                    <div key={index} className="document-card">
                      <div className="doc-icon">{doc.icon}</div>
                      <div className="doc-name fw-bold">{doc.name}</div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="age-criteria">
  <h3 className='h4 color fw-bold' >Age Eligibility Criteria</h3>
  <div className="age-chart">
    <div className="chart-container">
      {/* Kindergarten */}
      <div className="age-group">
        <div className="grade-label">Kindergarten</div>
        <div className="age-range">
          <div className="age-bubble">3-5 yrs</div>
          <div className="timeline-bar" style={{ width: '20%', backgroundColor: '#FF9AA2' }}></div>
        </div>
      </div>
      
      {/* Primary (Grade 1-5) */}
      <div className="age-group">
        <div className="grade-label">Primary (Grade 1-5)</div>
        <div className="age-range">
          <div className="age-bubble">5-10 yrs</div>
          <div className="timeline-bar" style={{ width: '40%', backgroundColor: '#FFB7B2' }}></div>
        </div>
      </div>
      
      {/* Middle School (Grade 6-8) */}
      <div className="age-group">
        <div className="grade-label">Middle School (Grade 6-8)</div>
        <div className="age-range">
          <div className="age-bubble">10-13 yrs</div>
          <div className="timeline-bar" style={{ width: '30%', backgroundColor: '#FFDAC1' }}></div>
        </div>
      </div>
      
      {/* High School (Grade 9-12) */}
      <div className="age-group">
        <div className="grade-label">High School (Grade 9-12)</div>
        <div className="age-range">
          <div className="age-bubble">13-17 yrs</div>
          <div className="timeline-bar" style={{ width: '40%', backgroundColor: '#E2F0CB' }}></div>
        </div>
      </div>
    </div>
    
    {/* Visual Timeline */}
    <div className="timeline-axis">
      <div className="axis-label">3</div>
      <div className="axis-label">5</div>
      <div className="axis-label">10</div>
      <div className="axis-label">13</div>
      <div className="axis-label">17</div>
    </div>
  </div>
</div>
            </div>
          </div>
        </div>
      </section>




      <div className="tuition-container container-fluid py-4">
  <div className="container">
    {/* Header */}
    <div className="row mb-4">
  <div className="col-12 text-center">
    <h3 className="h2 display-6 fw-bold mb-3">Tuition & Fees</h3>
    <p className="lead mb-3">
      Transparent pricing for all education levels with flexible payment options.
    </p>
    
  </div>
</div>

    {/* 3 Fee Tables - col-4 each */}
    <div className="row mb-4 d-none">
    <div className="description-section col-lg-12 mb-4 mb-lg-0">
        <p className="description-text mb-2">
          This new plan is designed to reduce the average cost of a Make School Education 
          while preserving the core protections of ISAs – if you don't have a job after 
          Make School, you should not have to pay until you are employed.
        </p>
      </div>
      {/* Primary School */}
      <div className="col-md-4 mb-3">
        <div className="p-3 border rounded">
          <h5 className="text-center bg-primary text-white p-2 rounded">Primary (3-5)</h5>
          <table className="table table-sm">
            <tbody>
              <tr><td>Admission</td><td className="text-end">500</td></tr>
              <tr><td>Tuition</td><td className="text-end">8,000</td></tr>
              <tr><td>Laptop</td><td className="text-end">1,200</td></tr>
              <tr><td>Activities</td><td className="text-end">300</td></tr>
              <tr className="table-active"><td>Total</td><td className="text-end fw-bold">10,000</td></tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Middle School */}
      <div className="col-md-4 mb-3">
        <div className="p-3 border rounded">
          <h5 className="text-center bg-success p-2 text-white rounded">Middle (6-9)</h5>
          <table className="table table-sm">
            <tbody>
              <tr><td>Admission</td><td className="text-end">600</td></tr>
              <tr><td>Tuition</td><td className="text-end">10,000</td></tr>
              <tr><td>Laptop</td><td className="text-end">1,500</td></tr>
              <tr><td>Activities</td><td className="text-end">400</td></tr>
              <tr className="table-active"><td>Total</td><td className="text-end fw-bold">12,500</td></tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* High School */}
      <div className="col-md-4 mb-3">
        <div className="p-3 border rounded">
          <h5 className="text-center bg-info p-2 text-white rounded">High (10-12)</h5>
          <table className="table table-sm">
            <tbody>
              <tr><td>Admission</td><td className="text-end">700</td></tr>
              <tr><td>Tuition</td><td className="text-end">12,000</td></tr>
              <tr><td>Laptop</td><td className="text-end">1,800</td></tr>
              <tr><td>Activities</td><td className="text-end">500</td></tr>
              <tr className="table-active"><td>Total</td><td className="text-end fw-bold">15,000</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    {/* Annual Summary Table - col-12 */}
    <div className="row mb-4">
  <div className="col-12">
    <div className="p-3 border rounded shadow-sm">
      <h5 className="text-center bg-primary p-2 text-white rounded mb-4">
        <i className="bi bi-cash-stack me-2"></i>Annual Fee Comparison
      </h5>
      
      {/* Desktop Table (visible on md and up) */}
      <div className="d-none d-md-block">
        <table className="table table-striped table-bordered table-hover">
          <thead className="table-dark">
            <tr>
              <th className="align-middle">Grade Level</th>
              <th className="text-end align-middle">Admission</th>
              <th className="text-end align-middle">Tuition</th>
              <th className="text-end align-middle">Laptop</th>
              <th className="text-end align-middle">Activities</th>
              <th className="text-end align-middle">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="fw-semibold">Primary (3-5)</td>
              <td className="text-end">$500</td>
              <td className="text-end">$8,000</td>
              <td className="text-end">$1,200</td>
              <td className="text-end">$300</td>
              <td className="text-end fw-bold text-primary">$10,000</td>
            </tr>
            <tr>
              <td className="fw-semibold">Middle (6-9)</td>
              <td className="text-end">$600</td>
              <td className="text-end">$10,000</td>
              <td className="text-end">$1,500</td>
              <td className="text-end">$400</td>
              <td className="text-end fw-bold text-primary">$12,500</td>
            </tr>
            <tr>
              <td className="fw-semibold">High (10-12)</td>
              <td className="text-end">$700</td>
              <td className="text-end">$12,000</td>
              <td className="text-end">$1,800</td>
              <td className="text-end">$500</td>
              <td className="text-end fw-bold text-primary">$15,000</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Mobile Cards (visible on sm and down) */}
      <div className="d-md-none">
        <div className="list-group">
          {/* Primary */}
          <div className="list-group-item p-3 mb-2 border rounded">
            <h6 className="fw-bold mb-3">Primary (3-5)</h6>
            <div className="d-flex justify-content-between mb-1">
              <span>Admission:</span>
              <span className="fw-medium">500</span>
            </div>
            <div className="d-flex justify-content-between mb-1">
              <span>Tuition:</span>
              <span className="fw-medium">8,000</span>
            </div>
            <div className="d-flex justify-content-between mb-1">
              <span>Laptop:</span>
              <span className="fw-medium">1,200</span>
            </div>
            <div className="d-flex justify-content-between mb-1">
              <span>Activities:</span>
              <span className="fw-medium">300</span>
            </div>
            <hr className="my-2" />
            <div className="d-flex justify-content-between fw-bold">
              <span>Total:</span>
              <span>10,000</span>
            </div>
          </div>
          
          {/* Middle */}
          <div className="list-group-item p-3 mb-2 border rounded">
            <h6 className="fw-bold mb-3">Middle (6-9)</h6>
            <div className="d-flex justify-content-between mb-1">
              <span>Admission:</span>
              <span className="fw-medium">600</span>
            </div>
            <div className="d-flex justify-content-between mb-1">
              <span>Tuition:</span>
              <span className="fw-medium">10,000</span>
            </div>
            <div className="d-flex justify-content-between mb-1">
              <span>Laptop:</span>
              <span className="fw-medium">1,500</span>
            </div>
            <div className="d-flex justify-content-between mb-1">
              <span>Activities:</span>
              <span className="fw-medium">400</span>
            </div>
            <hr className="my-2" />
            <div className="d-flex justify-content-between fw-bold">
              <span>Total:</span>
              <span>12,500</span>
            </div>
          </div>
          
          {/* High */}
          <div className="list-group-item p-3 border rounded">
            <h6 className="fw-bold mb-3">High (10-12)</h6>
            <div className="d-flex justify-content-between mb-1">
              <span>Admission:</span>
              <span className="fw-medium">700</span>
            </div>
            <div className="d-flex justify-content-between mb-1">
              <span>Tuition:</span>
              <span className="fw-medium">12,000</span>
            </div>
            <div className="d-flex justify-content-between mb-1">
              <span>Laptop:</span>
              <span className="fw-medium">1,800</span>
            </div>
            <div className="d-flex justify-content-between mb-1">
              <span>Activities:</span>
              <span className="fw-medium">500</span>
            </div>
            <hr className="my-2" />
            <div className="d-flex justify-content-between fw-bold">
              <span>Total:</span>
              <span>15,000</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

    {/* Small Download Button */}
    <div className="row">
      <div className="col-12 mt-3 text-center">
        <button className="btn custom-hover py-2 p-2 btn-sm">
          <FaDownload className="me-1" />
          Download Fee Details
        </button>
      </div>
    </div>
  </div>
</div>



      {/* Why Choose Us with Images */}
      <section className="why-choose-us d-none">
        <div className="container">
          <h2>Why Families Choose DNET</h2>
          <div className="features-grid">
            {whyChooseUs.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-image-container">
                  <img src={feature.image} alt={feature.title} className="feature-image" />
                  <div className="feature-icon">{feature.icon}</div>
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
 
      {/* Testimonials with Images */}
      <section className="testimonials-section">
  <div className="container">
    <h2 className='h2 display-6 fw-bold mb-3'>Hear From Our Parents</h2>
    <div className="testimonials-grid">
      {testimonials.map((testimonial, index) => (
        <div key={index} className="testimonial-card">
          <div className="testimonial-image">
            <img 
              src={testimonial.image} 
              alt={testimonial.author}
              className="profile-img"
            />
          </div>
          <div className="testimonial-content">
            <div className="quote">"{testimonial.quote}"</div>
            <div className="author color">- {testimonial.author}</div>
            <div className="child-info color">{testimonial.childGrade}</div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

      {/* Photo Gallery */}
      <section className="gallery-section d-none">
        <div className="container">
          <h2>Life at DNET</h2>
          <div className="gallery-grid">
            {[
              "assets/images/Courses/courses_1.webp",
              "assets/images/Courses/courses_2.webp",
              "assets/images/Courses/courses_3.webp",
              "assets/images/Courses/courses_4.webp",
              "assets/images/Courses/courses_5.webp",
              "assets/images/Courses/courses_6.webp",
              "assets/images/Courses/courses_2.webp",
              "assets/images/Courses/courses_3.webp"
            ].map((image, index) => (
              <div key={index} className="gallery-item">
                <img src={image} alt={`Campus Life {index + 1}`} />
              </div>
            ))}
          </div>    
        </div>
      </section>

      {/* FAQ */}
      <section className="faq-section py-5 d-none">
  <div className="container">
    <div className="row align-items-start">
      {/* Left Side - Student Thoughts/Questions */}
      <div className="col-lg-5 mb-4 mb-lg-0">
  <div className="student-questions p-4 rounded shadow-sm bg-light text-center">
    {/* Large question mark image as visual metaphor */}
    <div className="mb-4">
      <img 
        src="https://cdn-icons-png.flaticon.com/512/3652/3652191.png" 
        alt="Question mark" 
        className="img-fluid"
        width="150"
        height="150"
      />
    </div>
    
    {/* Decorative heading */}
    <h3 className="mb-3 text-primary">
      Have Questions? <br />
      <span className="text-muted fs-5">We Have Answers</span>
    </h3>
    
    {/* Decorative text */}
    <p className="text-muted">
      Browse our frequently asked questions or contact our admissions team for more information.
    </p>
  </div>
</div>

      {/* Right Side - FAQ Content */}
      <div className="col-lg-7">
        <h2 className="mb-4">Frequently Asked Questions</h2>
        <div className="faq-container">
          {[
            {
              question: "What is the application deadline?",
              answer: "We accept applications year-round, but priority consideration is given to applications received by March 1st for the upcoming academic year."
            },
            {
              question: "Is financial aid available?",
              answer: "Yes, we offer need-based financial aid to qualified families. Please contact our admissions office for more information."
            },
            {
              question: "What are your school hours?",
              answer: "Regular school hours are from 8:30 AM to 3:00 PM, with extended care options available until 6:00 PM."
            },
            {
              question: "Do you offer transportation services?",
              answer: "Yes, we provide bus transportation to most areas within the city. Routes and fees are available upon request."
            }
          ].map((item, index) => (
            <div key={index} className="faq-item mb-3 border-bottom">
              <div 
                className="faq-question d-flex justify-content-between align-items-center py-3 cursor-pointer"
                onClick={() => toggleAccordion(index)}
              >
                <h5 className="mb-0">{item.question}</h5>
                {activeAccordion === index ? <FaChevronUp /> : <FaChevronDown />}
              </div>
              {activeAccordion === index && (
                <div className="faq-answer pb-3">
                  <p className="mb-0">{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>

  <style jsx>{`
    .student-questions {
      position: sticky;
      top: 20px;
    }
    .bubble {
      position: relative;
      box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    }
    .bubble:before {
      content: '';
      position: absolute;
      left: -10px;
      top: 15px;
      width: 0;
      height: 0;
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-right: 10px solid white;
    }
    .cursor-pointer {
      cursor: pointer;
    }
    .bubble {
        position: relative;
        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        margin-left: 15px; /* Creates space instead of the pointer */
      }
    .faq-question:hover {
      background-color: #f8f9fa;
    }
  `}</style>
</section>

<section className="fee-cta " style={{ backgroundImage: "linear-gradient(rgba(8, 13, 13, 0.9), rgba(8, 12, 23, 0.9)), url('assets/images/error_img.webp')" }}>
        <div className="container">
          <h2 className=' display-6 fw-bold mb-3'>Ready to Learn More About Our Fee Structure?</h2>
          <p></p>
          {/* <button className="cta-button">Download Fee Structure</button> */}
        </div>
      </section>
<section className="FAQ mt-5 pt-4">
    <div className="container ">
      <div className="row justify-content-md-between flex-md-row flex-column-reverse gy-md-0 gy-4 mt-5">
        <div className="col-lg-5 col-md-5">
          <div className="position-relative">
            <figure className="m-0" data-aos="zoom-in-up">
              <img
                className="w-100"
                src="assets/images/index/FAQ_Img.webp"
                alt="FAQ_img"
              />
            </figure>
            <div>
              <img
                className="position-absolute"
                src="assets/images/index/OpenBook.webp"
                alt="OpenBook"
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-7">
          <div className="d-flex flex-column" data-aos="fade-up">
            <h1 style={{color:"#200D46"}}> FAQ</h1>
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h6 className="accordion-header">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    Lorem ipsum dolor sit amet?
                  </button>
                </h6>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse show"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. In vitae turpis massa sed elementum tempus egestas
                      sed. Diam in arcu cursus euismod. Dolor sed viverra ipsum
                      nunc aliquet bibendum enim facilisis gravida
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h6 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    Lorem ipsum dolor sit amet?
                  </button>
                </h6>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. In vitae turpis massa sed elementum tempus egestas
                      sed. Diam in arcu cursus euismod. Dolor sed viverra ipsum
                      nunc aliquet bibendum enim facilisis gravida
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h6 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    Lorem ipsum dolor sit amet?
                  </button>
                </h6>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. In vitae turpis massa sed elementum tempus egestas
                      sed. Diam in arcu cursus euismod. Dolor sed viverra ipsum
                      nunc aliquet bibendum enim facilisis gravida
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h6 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    Lorem ipsum dolor sit amet?
                  </button>
                </h6>
                <div
                  id="collapseFour"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. In vitae turpis massa sed elementum tempus egestas
                      sed. Diam in arcu cursus euismod. Dolor sed viverra ipsum
                      nunc aliquet bibendum enim facilisis gravida
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

      {/* Fee Structure CTA */}
      <section className="fee-cta d-none" style={{ backgroundImage: "linear-gradient(rgba(58, 13, 21, 0.9), rgba(58, 13, 21, 0.9)), url('assets/images/banner3.jpg')" }}>
        <div className="container">
          <h2>Ready to Learn More About Our Fee Structure?</h2>
          <p>Download our detailed fee breakdown and payment plan options</p>
          <button className="cta-button">Download Fee Structure</button>
        </div>
      </section>
    </div>
  );
};

export default Admissions;